<template lang="pug">
v-input(
  v-model="value"
  v-bind="$attrs"
  :required="isRequired && !isDisabled"
  :rules="rules"
)
  template(#label)
    span

  v-row.mt-n7
    v-col(cols="12")
      div.v-label.x-label.text-caption(
        style="margin-top: 7px; margin-bottom: -2px"
        :class="{ 'x-outlined': isOutlined }"
      )
        | {{ field.title || field.name }}

      v-btn-toggle.d-flex.flex-row(
        style="margin-bottom: -3px"
        ref="input"
        v-bind="$attrs"
        v-model="content"
        :dense="!isLarge"
        :label="myTitle"
        :hint="myHint"
        :hide-details="hasNoHints"
        @click:append="revealed = !revealed"
        @keyup.enter="$emit('action-performed', $refs.input)"
      )
        v-btn(
          :value="true"
          :small="!isLarge"
          :plain="isReadOnly"
          :class="{ 'flex-grow-1': !!myTrueText, ...btnColor(true) }"
          :disabled="isDisabled || (isReadOnly && content === false)"
        )
          span {{ myTrueText }}
          v-icon(
            small
            :color='iconColor(true)'
            :right="!!myTrueText"
          )
            | {{ myTrueIcon }}

        v-btn(
          :value="false"
          :small="!isLarge"
          :plain="isReadOnly"
          :class="{ 'flex-grow-1': !!myFalseText, ...btnColor(false) }"
          :disabled="isDisabled || (isReadOnly && content === true)"
        )
          v-icon(
            small
            :color='iconColor(false)'
            :left="!!myFalseText"
          )
            | {{ myFalseIcon }}
          span {{ myFalseText }}
</template>

<style scoped>
/* .x-active {
  background-color: var(--v-primary-base) !important;
  color: white !important;
} */
.x-active .v-icon {
  color: white !important;
}
.x-widget-boolean button {
  min-width: 40px !important;
  min-height: 30px !important;
}
</style>

<script>
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { interpolate, isInterpolated } from '@/helpers/strings'

export default {

  props: {
    /**
     * Objeto contendo os valores e campos do contexto no qual o widget está
     * inserido para inferência de propriedades aplicadas em interpolação de
     * templates de texto.
     */
    context: Object,

    /**
     * Instância opcional de um campo do Paper.
     * @type {Keep.Paper.Design.Field}
     */
    field: Object,

    /**
     * Um dos tipos de dados suportados pelo Paper.
     * @type {Keep.Paper.Design.TypeNames}
     */
    dataType: String,

    /**
     * Diz se o componente suporta seleção de intervalo.
     * @type {Boolean}
     */
    allowRange: Boolean,

    /**
     * Valor editado no componente.
     * @type {Any}
     */
    value: {
      validator: v => true
    },

    // Propriedades de {Keep.Paper.Design.Field} que podem ser sobrescritas...
    name: String,
    title: String,
    outlined: Boolean,
  },

  data: () => ({
    icons: {
      mdiEyeOutline,
      mdiEyeOffOutline,
    },

    toggle_exclusive: 2,

    revealed: false
  }),

  computed: {
    myName: vm => vm.getIt('name'),
    myTitle: vm => vm.getIt('title') || vm.myName,
    myDescription: vm => vm.getIt('description'),
    myHint: vm => vm.getIt('hint'),
    myPlaceholder: vm => vm.getIt('placeholder'),
    isSecure: vm => vm.hasIt('secure'),
    isLarge: vm => vm.hasIt('large'),
    hasNoHints: vm => vm.hasIt('noHints'),
    isRequired: vm => vm.hasIt('required'),
    isOutlined: vm => vm.hasIt('outlined'),
    isDisabled: vm => vm.hasIt('disabled'),
    isReadOnly: vm => vm.hasIt('readOnly') || vm.hasIt('readonly'),

    myTrueText: vm => vm.getIt('trueText') || (vm.hasIt('trueIcon') ? null : 'Sim'),
    myTrueIcon: vm => vm.getIt('trueIcon'),
    myFalseText: vm => vm.getIt('falseText') || (vm.hasIt('falseIcon') ? null : 'Não'),
    myFalseIcon: vm => vm.getIt('falseIcon'),

    content: {
      get () {
        return (this.value === null || this.value === undefined)
          ? null : !!this.value
      },
      set (value) {
        if (this.isReadOnly) return
        this.$emit('input', value === undefined ? null : value)
      }
    },

    rules () {
      const required = this.isRequired && !this.isDisabled
      return [
        v => !required || (v !== null && v !== undefined) || 'Campo requerido',
      ]
    },
  },

  methods: {
    getIt (property) {
      return this[property]
        || this.$props[property]
        || this.$attrs[property]
        || this.field?.[property]
    },
    hasIt (property) {
      if (this.$props[property] === '') return true
      if (this.$attrs[property] === '') return true
      const value = this[property]
        || this.$props[property]
        || this.$attrs[property]
        || this.field?.[property]
      return !!value
    },

    format(text) {
      return isInterpolated(text) ? interpolate(text, this.context) : text
    },

    btnColor(expectation) {
      const readonly = this.isReadOnly
      const on = this.content === expectation
      return {
        'primary': on && !readonly,
        'secondary': on && readonly
      }
    },

    iconColor(expectation) {
      const on = this.content === expectation
      return on ? 'white' : ''
    },
  },
}
</script>